<vwui-form-group class="filter-input__group" [formGroup]="optionsControl">
    <ng-container *ngFor="let control of optionsControl.controls | keyvalue">
        <div [formGroupName]="control.key" *ngIf="optionsControl.get(control.key)">
            <vwui-checkbox formControlName="selected">
                {{ optionsControl.get(control.key).value.name }}
            </vwui-checkbox>
        </div>
    </ng-container>
</vwui-form-group>
